import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ChecklistComponent } from './components/checklist/checklist.component';

@NgModule({
    declarations: [ChecklistComponent],
    imports: [CommonModule, SharedModule],
    exports: [ChecklistComponent]
})
export class ChecklistModule {}
